/** Reference lead time vs actual: `{ref}{unit}` (variance) + status. Variance = actual − reference. */
export const renderLeadTimeVariance = (reference, actual, unitSuffix = 'D') => {
	if (actual == null || actual === '' || actual === undefined) return ' ';
	const v = Number(actual) - Number(reference);
	const inner = Number.isNaN(v) ? '' : v;
	const status =
		v === 0
			? { tone: 'green-3', label: 'on time' }
			: v >= 1
				? { tone: 'red-3', label: 'Delayed' }
				: { tone: 'green-3', label: 'Early' };

	return (
		<>
			<p className="regular-14  gray_dark_02 mb-0">
				{reference}
				{unitSuffix} (<span className="regular-14  gray_dark_02 mb-0">{inner}</span>)
			</p>
			<span className={`status ${status.tone} status-with-border`}>{status.label}</span>
		</>
	);
};

export const Task_PRIORITY_OPTIONS = [
	{ id: 2, name: 'High', value: 'HIGH' },
	{ id: 1, name: 'Standard', value: 'STANDARD' }
	// { id: 3, name: 'Express', value: 'EXPRESS' }
];

const getDashboardGroupKey = (item, groupBy) => {
	const keyMap = {
		REQUEST_PRIORITY: () => {
			const match = Task_PRIORITY_OPTIONS.find((o) => o.value === item?.taskPriority);
			return match?.name ?? 'Others';
		},

		MARKET_AND_CATEGORY: () => {
			const market = item?.productGroup || 'No Market';
			const category = item?.name || 'No Category';
			return `${market} - ${category}`;
		},

		MARKET_AND_FABRIC: () => {
			const market = item?.productGroup || 'No Market';
			const fabric = item?.mainFabricType || 'No Fabric';
			return `${market} - ${fabric}`;
		},

		COLLECTION: () => {
			return item?.collectionName || 'No Collection';
		},

		///sample journey group by
		REQUEST: () => {
			const requestId =
				item?.inHouseDevelopmentJourneyDetails?.requestId ??
				item?.costingJourneyDetailsResponse?.requestId ??
				item?.factoryDevelopmentJourneyDetails?.requestId ??
				item?.graphicsJourneyDetails?.requestId ??
				item?.threeDJourneyDetails?.requestId;
			const brandName =
				item?.inHouseDevelopmentJourneyDetails?.brandResponse?.name ??
				item?.costingJourneyDetailsResponse?.brandResponse?.name ??
				item?.factoryDevelopmentJourneyDetails?.brandResponse?.name;
			const rawRef =
				item?.inHouseDevelopmentJourneyDetails?.requestReference ??
				item?.costingJourneyDetailsResponse?.systemReferenceNumber ??
				item?.factoryDevelopmentJourneyDetails?.requestReference;
			const trimmed = rawRef != null ? String(rawRef).trim() : '';
			const systemReferenceNumber = trimmed !== '' ? `#${trimmed}` : '';
			const collectionName =
				item?.costingJourneyDetailsResponse?.collectionName ??
				item?.factoryDevelopmentJourneyDetails?.collectionOrFolderName ??
				item?.factoryDevelopmentJourneyDetails?.collectionName ??
				item?.inHouseDevelopmentJourneyDetails?.collectionOrFolderName ??
				item?.collectionName;
			const requestTitle = [brandName, systemReferenceNumber, collectionName]
				.map((value) => (value != null ? String(value).trim() : ''))
				.filter(Boolean)
				.join(' | ');
			if (requestId != null && String(requestId).trim() !== '') {
				return requestTitle || 'No request';
			}
		}
	};

	return keyMap[groupBy] ? keyMap[groupBy]() : null;
};

export const dashboardGroupBy = (data, selectedGroupBy) => {
	if (!selectedGroupBy) return null;

	const acc = data.reduce((grouped, item) => {
		const key = getDashboardGroupKey(item, selectedGroupBy);
		if (key) {
			grouped[key] = grouped[key] || [];
			grouped[key].push(item);
		}
		return grouped;
	}, {});

	if (selectedGroupBy !== 'REQUEST_PRIORITY') return acc;

	const order = [...Task_PRIORITY_OPTIONS.map((o) => o.name), 'Others'];
	const keys = [...order.filter((k) => k in acc), ...Object.keys(acc).filter((k) => !order.includes(k))];

	return Object.fromEntries(keys.map((k) => [k, acc[k]]));
};

/** Costing quote item statuses (aligned with API `quoteItemResponse.status`). */
export const COSTING_OFFER_STATUS = {
	OFFER_SENT: 'OFFER_SENT',
	REQUEST_FOR_REVISION: 'REQUEST_FOR_REVISION'
};

export const formatDashboardDate = (value) => {
	if (!value) return '';

	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return value;

	const day = String(date.getDate()).padStart(2, '0');
	const month = date.toLocaleString('en-US', { month: 'short' });
	const year = String(date.getFullYear()).slice(-2);

	return `${day}-${month}-${year}`;
};

export const handleTextareaHeight = (e) => {
	e.target.style.height = 'auto';
	e.target.style.height = `${e.target.scrollHeight}px`;
};
